var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-print",on:{"click":_vm.doPrint}},[_c('i',{staticClass:"u-icon el-icon-printer"}),_c('span',{staticClass:"u-text"},[_vm._v("打印 | 保存PDF")])])}
var staticRenderFns = []

export { render, staticRenderFns }